/**
 * @fileOverview Custom checkbox
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires ../00-utilities/delegate.js
 */

import delegate from '../00-utilities/delegate';

export default class Checkbox {
  constructor() {
    delegate({
      target: '.checkbox__shape',
      listener: this.onSpaceBarKeyDown.bind( this ),
      event: 'keydown'
    })
  }

  /**
   * Changes the status on spacebar press.
   * @param  {Object} e - The event that triggered the function.
   */
  onSpaceBarKeyDown( e ) {
    let input = e.target.previousElementSibling;
    if ( e.which == 32 && !input.disabled ) {
      e.preventDefault();
      const
        eventInput = new Event( 'input', {
          'bubbles': true,
          'cancelable': true
        }),
        eventChange = new Event( 'change', {
          'bubbles': true,
          'cancelable': true
        });
      e.target.previousElementSibling.dispatchEvent( eventInput );
      e.target.previousElementSibling.dispatchEvent( eventChange );
      e.target.previousElementSibling.checked = !e.target.previousElementSibling.checked;
    }
  }
}
